import { Link } from "react-router-dom";
import { Mail, Instagram } from "lucide-react";

// Shared editorial two-column layout used by all Innayaa policy pages.
export function PolicySection({ n, title, children }) {
  return (
    <section className="border-t border-[#DCD5CA] pt-8 md:pt-10 mt-8 md:mt-10 first:border-t-0 first:mt-0 first:pt-0">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10">
        <div className="md:col-span-3">
          <p className="overline">Section {n}</p>
        </div>
        <div className="md:col-span-9">
          <h2 className="font-serif text-2xl md:text-3xl tracking-tight text-[#2A2626] leading-tight">
            {title}
          </h2>
          <div className="mt-4 md:mt-5 text-[15px] leading-[1.85] text-[#5C564F] space-y-4">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}

export default function PolicyLayout({ testId, overline, title, italicWord, intro, children, updated }) {
  return (
    <div data-testid={testId} className="bg-[#FAF8F5]">
      <section className="border-b border-[#DCD5CA] bg-[#F0EBE1]/60">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-6 md:px-10 lg:px-16 py-14 md:py-20">
          <p className="overline">{overline}</p>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05] text-[#2A2626]">
            {title}
            {italicWord && (
              <>
                <br />
                <span className="italic font-light">{italicWord}</span>
              </>
            )}
          </h1>
          {intro && (
            <p className="mt-6 text-[15px] md:text-base text-[#5C564F] max-w-2xl leading-relaxed">
              {intro}
            </p>
          )}
          {updated && (
            <p className="mt-4 text-[11px] uppercase tracking-[0.22em] text-[#5C564F]">
              Last updated: {updated}
            </p>
          )}
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-5 sm:px-6 md:px-10 lg:px-16 py-14 md:py-20">
        {children}
      </section>

      <section className="bg-[#F0EBE1]/70 border-t border-[#DCD5CA]">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-6 md:px-10 lg:px-16 py-14 md:py-20 text-center">
          <p className="overline">Contact Us</p>
          <h2 className="mt-4 font-serif text-3xl md:text-4xl tracking-tight text-[#2A2626]">
            Any questions? We&rsquo;re here.
          </h2>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-5 md:gap-8 text-[#2A2626]">
            <a href="mailto:innayaaofficial@gmail.com" className="inline-flex items-center gap-2.5 font-serif text-lg md:text-xl hover:opacity-70">
              <Mail size={18} strokeWidth={1.5} />
              innayaaofficial@gmail.com
            </a>
            <a href="https://www.instagram.com/innayaa.in/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 font-serif text-lg md:text-xl hover:opacity-70">
              <Instagram size={18} strokeWidth={1.5} />
              @innayaa.in
            </a>
          </div>
          <div className="mt-10">
            <Link to="/shop" className="inline-block bg-[#2A2626] text-[#FAF8F5] px-9 py-4 text-[11px] uppercase tracking-[0.28em] hover:bg-[#3A3632] transition-colors">
              Back to shop
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
